import React, { PureComponent } from 'react';
import { PrivacyPolicy, HipaaConsent, TermsOfService } from '../LegalLinks';

class TosLinks extends PureComponent {
  render = () => (
    <span>
      I have read, understand, and agree to Solv Health's <TermsOfService />, <PrivacyPolicy />, and{' '}
      <HipaaConsent />.
    </span>
  );
}

export default TosLinks;
